import { AbstractShape } from "../abstract/Shape";
import { COptionsResponse } from "../clases/COptionsResponse";
import { obtainFullRelation, obtainRelation } from "./utils";
import { DBItem } from '../interfaces/Record';
import { createCanvasItem, getShapeWithNodeId } from "./ContainerUtils";
import { CanvasItem } from "../clases/CanvasItem";
import { INeo4j } from "../interfaces/Neo4j";

export function hierarchyLoop(nodes: DBItem[], relations: DBItem[], hierarchy: COptionsResponse[], list: AbstractShape[], main: AbstractShape[], parent?: AbstractShape, used: boolean = true) {
  for (const h of hierarchy) {
    let labelNodes = [];
    if (parent) {
      labelNodes = nodes.filter(n => {
        let existLabel = n.labels.includes(h.label);
        let relation = obtainFullRelation(n.elementId, parent.dbData.elementId, h.relationship, relations);
        return existLabel && relation;
      });
    } else {
      labelNodes = nodes.filter(n => {
        let existLabel = n.labels.includes(h.label);
        let relation = obtainRelation(n.elementId, h.relationship, relations);
        return existLabel && relation;
      });
    }
    if (labelNodes.length <= 0 && h.containers.length && !parent) {
      hierarchyLoop(nodes, relations, h.containers as COptionsResponse[], list, main, undefined, used);
    }
    for (const node of labelNodes) {
      let item: CanvasItem | undefined = getShapeWithNodeId(node.elementId, main) as CanvasItem;
      if (!item) {
        item = createCanvasItem(node);
      }
      if (h.containers.length > 0) {
        hierarchyLoop(nodes, relations, h.containers as COptionsResponse[], item.children, main, item, used);
      }
      let alreadyIn = getShapeWithNodeId(node.elementId, list);
      if (!alreadyIn) {
        if (!parent) {
          item.dbData.isUsed = used;
          list.push(item);
          continue;
        }
        let relation = obtainFullRelation(item.dbData.elementId, parent.dbData.elementId, h.relationship, relations);
        if (!relation) {
          continue;
        }
        let alreadyOnMainList = main.find((it: AbstractShape)=>it.dbData.elementId===item.dbData.elementId);
        if(alreadyOnMainList){
          const indexToRemove = main.findIndex((it: AbstractShape)=>it.dbData.elementId===item.dbData.elementId);
          main.splice(indexToRemove, 1);
        }
        parent.setRelationType(relation!.properties.name);
        item.dbData.isUsed = used;
        parent.addChild(item);
      }
    }
  }
}

export function hierarchyLoopSimple(nodes: DBItem[], relations: DBItem[], main: AbstractShape[], used: boolean = true) {
  for (const relation of relations) {
    let startID = relation.startNodeElementId;
    let endID = relation.endNodeElementId;
    let startNode = nodes.find((node: DBItem)=>node.elementId === startID);
    let endNode = nodes.find((node: DBItem)=>node.elementId === endID);
    if(!startNode || !endNode) {return;}
    let startItem = getShapeWithNodeId(startID, main) as CanvasItem || createCanvasItem(startNode);
    let endItem = getShapeWithNodeId(endID, main) as CanvasItem || createCanvasItem(endNode);
    let alreadyIn = getShapeWithNodeId(startID, endItem.children);
    if(alreadyIn) return;
    endItem.setRelationType(relation!.properties.name);
    detachBoxById(startID, main);
    endItem.addChild(startItem);
    startItem.dbData.isUsed = used;
    if(!endItem.parent){
      main.push(endItem);
      endItem.dbData.isUsed = used;
    }
    removeDuplicates(main);
  }
}

function detachBoxById(id: string, list: AbstractShape[]): AbstractShape | undefined {
  for (let i = 0; i < list.length; i++) {
    const b = list[i];
    if (b.id === id) {
      list.splice(i, 1);
      return b;
    }
    const removed = detachBoxById(id, b.children);
    if (removed) return removed;
  }
  return undefined;
}

function removeDuplicates<T>(arr: T[]): void {
  const seen = new Set<T>();
  let writeIndex = 0;

  for (let i = 0; i < arr.length; i++) {
    if (!seen.has(arr[i])) {
      seen.add(arr[i]);
      arr[writeIndex++] = arr[i];
    }
  }
  arr.length = writeIndex;
}

export function obtainHierachy(relations: DBItem[], json: INeo4j) {
  let hierarchiesFounded = obtainHierachyNames(relations);
  let list = json.connection.hierarchy.filter((h) => hierarchiesFounded.includes(h.relationship));
  const sortedObjects = list.sort((a, b) => {
    if (a.relationship === "EDT_ROOT" && b.relationship !== "EDT_ROOT") return -1;
    if (a.relationship !== "EDT_ROOT" && b.relationship === "EDT_ROOT") return 1;
    return 0;
  });
  return sortedObjects;
}

export function obtainHierachyNames(relations: DBItem[]) {
  return Array.from(
    relations.reduce((map, item) => {
      if (!map.has(item.properties.name)) {
        map.set(item.properties.name, item);
      }
      return map;
    }, new Map<string, DBItem>()).values()).map((r) => r.properties.name);
}